/**
 * Network Component for creating breakpoint-specific code blocks using matchMedia
 */
export default class Breakpoints {

  /**
   * Start component (called when Network starts)
   */
  constructor() {
    this.queries = {};
    this.breakpoints = {
      xl: '75rem',
      l: '60.625em',
      m: '48rem',
      s: '30rem',
    };
  }

  /**
   * Create a matchMedia instance for a breakpoint or set of breakpoints
   *
   * @param {string} fromBreakpoint - Key for minimum width value (pass false for no min width)
   * @param {string} toBreakpoint - Key for maximum width value (pass false for no max width)
   */
  generateMedia(fromBreakpoint, toBreakpoint = false) {
    let fromMedia = null;
    let toMedia = null;
    let mediaString = null;

    if (this.breakpoints && (fromBreakpoint || toBreakpoint)) {
      // Create string for minimum breakpoint
      if (fromBreakpoint && this.breakpoints[fromBreakpoint]) {
        fromMedia = `(min-width: ${this.breakpoints[fromBreakpoint]})`;
      }

      // Create string for maximum breakpoint
      if (toBreakpoint && this.breakpoints[toBreakpoint]) {
        toMedia = `(max-width: ${this.breakpoints[toBreakpoint]})`;
      }

      // Concat strings, or set to "from" or "to" value
      if (fromMedia && toMedia) {
        mediaString = `${fromMedia} and ${toMedia}`;
      } else if (fromMedia && ! toMedia) {
        mediaString = fromMedia;
      } else if (! fromMedia && toMedia) {
        mediaString = toMedia;
      }

      // Hold all existing queries in an object
      if (! this.queries[mediaString]) {
        this.queries[mediaString] = window.matchMedia(mediaString);
      }

      return this.queries[mediaString];
    }

    return false;
  }
}
